module.exports = __webpack_public_path__ + "static/media/kyoto5.5958efb6.jpg";